wonderwp.CachePluginComponent = function () {
  this.debug = false;
  this.storageKey = 'wwp-cache';
  this.storageEnabled = true;
  this.EventManager = window.EventManager || jQuery(document);
  this._initialLoadDone = false;
  this._fetchInProgress = false;
  this.onCacheNeedsRefresh(this.EventManager);
  var self = this;
  setTimeout(function () {
    self.loadCacheData();
  }, 50);
};

wonderwp.CachePluginComponent.prototype = {

  loadCacheData: function () {
    if (!wonderwp.cache_enabled) {
      return false;
    }
    if (!wonderwp.cacheConfig || !wonderwp.cacheConfig.uri) {
      throw new Error('Missing wwp-cache api cache uri');
    }

    if (this._fetchInProgress) {
      this.log('Load Cache Data skipped (fetch already in progress)');
      return false;
    }

    var res = this.storageEnabled ? sessionStorage.getItem(this.storageKey) : false;
    if (res) {
      this.log('Load Cache Data (storage)');
      this._initialLoadDone = true;
      this.onCacheLoadSuccess(JSON.parse(res));
    } else {
      this.log('Load Cache Data (api)');
      var self = this;
      this._fetchInProgress = true;
      jQuery.get(wonderwp.cacheConfig.uri, {}, function (res) {
        self._fetchInProgress = false;
        if (res && res.code && res.code === 200) {
          sessionStorage.setItem(self.storageKey, JSON.stringify(res));
          self._initialLoadDone = true;
          self.onCacheLoadSuccess(res);
        } else {
          self.onCacheLoadError(res);
        }
      }, 'json').fail(function () {
        self._fetchInProgress = false;
      });
    }
  },

  onCacheLoadSuccess: function (res) {
    this.log('Emit wwp-cache-onCacheLoadSuccess');
    this.EventManager.trigger('wwp-cache-onCacheLoadSuccess', {
      res: res
    });
  },

  onCacheLoadError: function (res) {
    this.EventManager.trigger('wwp-cache-onCacheLoadError', {
      res: res
    });
  },

  onCacheNeedsRefresh: function (EventManager) {
    var self = this;
    EventManager.on('wwp-cache-onCacheNeedsRefresh', function () {
      self.log('wwp-cache-onCacheNeedsRefresh');
      sessionStorage.removeItem(self.storageKey);
      if (self._initialLoadDone) {
        self.loadCacheData();
      }
    });
  },

  log: function (msg) {
    if (this.debug) {
      console.log('[Cache Component] ', msg);
    }
  }

};
